<template></template>

<script>
export default {
    name: "ProductDetailView",

    props: {
        brandTitle: {
            type: String
        },
        productTitle: {
            type: String
        },
        crmId: {
            type: [Number, String]
        }
    },

    mounted() {
        this.pushToDataLayer();
    },

    methods: {
        pushToDataLayer() {
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push({
                'event': 'productDetail',
                'ecommerce': {
                    'detail': {
                        'actionField': {'list': 'Product Detail Page'},
                        'products': [{
                            'name': this.productTitle?.toLowerCase(),
                            'id': this.crmId,
                            'brand': this.brandTitle,
                        }],
                    }
                }
            });
        }
    }
}
</script>